/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Extractionprompt1Inputs */

const en__field_extractionprompt1 = /** @type {(inputs: _Field_Extractionprompt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction prompt`)
};

/** @type {(inputs: _Field_Extractionprompt1Inputs) => LocalizedString} */
const de__field_extractionprompt1 = en__field_extractionprompt1;

/**
* | output |
* | --- |
* | "Extraction prompt" |
*
* @param {_Field_Extractionprompt1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_extractionprompt1 = /** @type {((inputs?: _Field_Extractionprompt1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Extractionprompt1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_extractionprompt1(inputs)
	return de__field_extractionprompt1(inputs)
});
export { _field_extractionprompt1 as "_field_extractionPrompt" }